/**
 * Enable POS inventory counts on PDP, relaunch
 */
export const PDP_INVENTORY_COUNTS_RELAUNCH_241031 = 'PDP_INVENTORY_COUNTS_RELAUNCH_241031';
